import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Tabs, Tab, Button, ButtonToolbar, Col } from 'react-bootstrap';
import Toggle from 'react-toggle';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';
import { PointsOfInterestCommand } from '../commands/PointsOfInterestCommand';
import { ActivePOIs } from './ActivePOIsList';
import { POIActiveForm } from './POIActiveForm';
import { PointsOfInterestDraftCommand } from '../commands/PointsOfInterestDraftCommand';
import { DraftPOIs } from './DraftPOIsList';
import { POIDraftForm } from './POIDraftForm';

export class PointsOfInterest extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    pois: [],
                },
                draft: {
                    pois: [],
                }
            },
            form: {
                active: {
                    poi: undefined
                },
                draft: {
                    poi: undefined
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 10
                },
                draft: {
                    page: 1,
                    elementsPerPage: 10
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingRegions: true,
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    pois: new PointsOfInterestCommand(),
                },
                draft: {
                    pois: new PointsOfInterestDraftCommand(),
                }
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    // ----------------------

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ---------------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateCounty() {
        const { actions } = this.state;

        actions.active.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getPOIs(edition, "active");
        });
    }

    updateDraftCounty() {
        const { actions } = this.state;

        actions.draft.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getPOIs(edition, "draft");
        });
    }

    // ----------------------

    getPOIs(edition, dataType) {
        const { actions, commands } = this.state;

        actions.isLoading = true;

        this.setState({
            actions: actions
        });

        actions[dataType].isLoading = true;
        commands[dataType].pois.get(
            edition,
            (a) => this.listSuccessCallback(a, dataType, "pois", "isLoading"),
            (a) => this.listErrorCallback(a, dataType, "pois", "isLoading")
        );
    }

    // ----------------------

    listCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.list[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        if (undefined === form[dataType].poi.obj.name || null === form[dataType].poi.obj.name || "" === form[dataType].poi.obj.name) {
            form[dataType].poi.nameInputError = 'error';
            errors++;
        }

        if (isNaN(form[dataType].poi.obj.coordX) || form[dataType].poi.obj.coordX === '') {
            form[dataType].poi.coordXInputError = 'error';
            errors++;
        }

        if (isNaN(form[dataType].poi.obj.coordY) || form[dataType].poi.obj.coordY === '') {
            form[dataType].poi.coordYInputError = 'error';
            errors++;
        }


        if ("" === form[dataType].poi.obj.type || null === form[dataType].poi.obj.type || undefined === form[dataType].poi.obj.type) {
            form[dataType].poi.typeInputError = 'error';
            errors++;
        }

        if ("draft" === dataType && (undefined === form[dataType].poi.obj.countyEditionId || null === form[dataType].poi.obj.countyEditionId || "" === form[dataType].poi.obj.countyEditionId)) {
            form[dataType].poi.editionInputError = 'error';
            errors++;
        }

        if (!form[dataType].poi.obj.workingHours.every(elem => this.isValidWorkingHours(elem))) {
            form[dataType].poi.workingHoursInputError = 'error';
            errors++;
        }

        if (!form[dataType].poi.obj.contacts.every(elem => this.isValidContact(elem))) {
            form[dataType].poi.contactsInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    isValidWorkingHours(workingHours) {
        return undefined !== workingHours && null !== workingHours && "" !== workingHours
    }

    isValidContact(contact) {
        return undefined !== contact && null !== contact && "" !== contact
    }

    // ----------------------
    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].poi.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onChangeListValue(operation, property, value, index, dataType) {
        const { form } = this.state;

        switch (operation) {
            case "add":
                form[dataType].poi.obj[property].push(value);
                break;
            case "update":
                form[dataType].poi.obj[property][index] = value;
                break;
            case "delete":
                form[dataType].poi.obj[property] = form[dataType].poi.obj[property].filter(current => value !== current);
                break;
            default:
                break;

        }

        this.setState({
            form: form
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        if (value !== "type") {
            form[dataType].poi.obj[value] = e;
        } else {
            form[dataType].poi.obj[value] = e.value;
        }

        this.setState({
            form: form,
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].poi = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                name: "",
                description: "",
                coordX: 0,
                coordY: 0,
                type: 0,
                workingHours: [],
                contacts: []
            },
            nameInputError: null,
            coordXInputError: null,
            coordYInputError: null,
            typeInputError: null,
            editionInputError: null,
            workingHoursInputError: null,
            contactsInputError: null
        };

        this.setState({
            form: form
        });
    }

    onEditClick(poi, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            poi = data[dataType].pois.find(unmutedPOI => unmutedPOI.id === poi.id);
        }

        form[dataType].poi = {
            title: "Editar",
            type: "edit",
            original: poi,
            obj: Object.assign({
                id: 0,
                name: "",
                description: "",
                coordX: 0,
                coordY: 0,
                type: 0,
                workingHours: [],
                contacts: []
            }, poi),
            nameInputError: null,
            coordXInputError: null,
            coordYInputError: null,
            typeInputError: null,
            editionInputError: null,
            workingHoursInputError: null,
            contactsInputError: null
        };

        form[dataType].poi.obj.workingHours = form[dataType].poi.obj.workingHours.slice();
        form[dataType].poi.obj.contacts = form[dataType].poi.obj.contacts.slice();

        this.setState({
            form: form
        });
    }

    onDeleteClick(poi, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar o ponto de interesse "${poi.name}"?`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: poi.id,
                    dataType: dataType
                }
            }
        });
    }

    onPOIFormExit(dataType) {
        const { form } = this.state;

        form[dataType].poi = undefined;

        this.setState({
            form: form
        });
    }

    onSavePOI(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdating = true;

            const callback = () => this.getPOIs(edition, dataType);
            commands[dataType].pois.save(
                edition,
                form[dataType].poi.obj,
                (a) => this.operationSuccessCallback(a, "isUpdating", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onPOIFormExit(dataType);
        }
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { edition } = this.context;
            const { commands } = this.state;

            if (argument.operation === "delete") {
                actions[argument.dataType].isDeleting = true;
                commands[argument.dataType].pois.delete(
                    edition,
                    argument.id,
                    (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getPOIs(edition, argument.dataType)),
                    (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                );
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------
    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderActivePOIs()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderDraftPOIs()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    renderActivePOIs() {
        const { data, actions, render, pagination } = this.state;

        return (
            <ActivePOIs pois={data.active.pois}
                draftPOIs={data.draft.pois}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isLoading || (render.compare && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderDraftPOIs() {
        const { data, actions, pagination, render } = this.state;

        return (
            <DraftPOIs pois={data.draft.pois}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isLoading}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.poi) {
            return null;
        }

        return (
            <POIActiveForm show={true}
                form={form.active.poi}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onChangeListValue={(a, b, c, d) => this.onChangeListValue(a, b, c, d, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onSave={() => this.onSavePOI("active")}
                onHide={() => this.onPOIFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.poi) {
            return null;
        }

        return (
            <POIDraftForm show={true}
                form={form.draft.poi}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onChangeListValue={(a, b, c, d) => this.onChangeListValue(a, b, c, d, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onSave={() => this.onSavePOI("draft")}
                onHide={() => this.onPOIFormExit("draft")} />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Pontos de Interesse" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {this.renderOperationFeedback("A Executar...", actions.active.isUpdating || actions.active.isDeleting || actions.draft.isUpdating || actions.draft.isDeleting)}
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pointsOfInterest/PointsOfInterest.js